import debounce from 'lodash/debounce';
import { useCallback, useMemo, useState } from 'react';
import { MapRef } from 'react-map-gl/maplibre';
import {
  resetDraftRouteGeometryAction,
  useAppDispatch,
} from '../../../../../redux';
import { SNAPPING_LINE_LAYER_ID, removeRoute } from '../../Utils';
import { LineStringFeature } from '../types';
import { useRouteGeometryUpdater } from './useRouteGeometryUpdater';

export function useSnappingLine(map: MapRef | undefined) {
  const dispatch = useAppDispatch();
  const [snappingLine, setSnappingLine] = useState<LineStringFeature | null>(
    null,
  );

  const removeSnappingLine = useCallback(() => {
    setSnappingLine(null);
    if (map) {
      removeRoute(map.getMap(), SNAPPING_LINE_LAYER_ID);
      dispatch(resetDraftRouteGeometryAction());
    }
  }, [dispatch, map]);

  const onUpdateRouteGeometry = useRouteGeometryUpdater(
    map,
    removeSnappingLine,
  );

  const debouncedOnAddRoute = useMemo(
    () => debounce(onUpdateRouteGeometry, 500),
    [onUpdateRouteGeometry],
  );

  return {
    snappingLine,
    setSnappingLine,
    removeSnappingLine,
    debouncedOnAddRoute,
  };
}
